import Dexie from 'dexie';
import { logError } from '../firebase/logs';

/**
 * Executa diversos testes para tentar identificar antecipadamente
 * possíveis causas do erro "UnknownError: Internal error" do Dexie/IndexedDB.
 * Retorna um objeto com uma lista de problemas encontrados.
 */
export async function checkDexieEnvironment() {
    const issues = [];

    if (typeof window === 'undefined') {
        issues.push({ code: 'no-window', message: 'Ambiente sem objeto window.' });
        return { ok: false, issues };
    }

    if (!('indexedDB' in window)) {
        issues.push({ code: 'no-indexeddb', message: 'IndexedDB n\u00e3o \u00e9 suportado neste ambiente.' });
        return { ok: false, issues };
    }

    let testDb;
    try {
        // Tenta abrir um banco de teste para verificar se h\u00e1 acesso ao IndexedDB
        testDb = new Dexie('dexie_env_test');
        testDb.version(1).stores({ t: '&id' });
        await testDb.open();
        await testDb.table('t').put({ id: 1 });
    } catch (error) {
        // Ao capturar UnknownError tentamos obter mais detalhes
        if (error?.name === 'UnknownError') {
            try {
                const persisted = await navigator.storage?.persisted?.();
                if (persisted === false) {
                    issues.push({ code: 'no-permission', message: 'Sem permiss\u00e3o de armazenamento persistente.' });
                }
            } catch (e) {
                logError(e, { function: 'checkDexieEnvironment', stage: 'persisted' });
            }
            try {
                const estimate = await navigator.storage?.estimate?.();
                if (estimate?.quota !== undefined && estimate?.usage !== undefined) {
                    const remaining = estimate.quota - estimate.usage;
                    if (remaining < 5 * 1024 * 1024) {
                        issues.push({ code: 'low-space', message: 'Pouco espa\u00e7o de armazenamento dispon\u00edvel.' });
                    }
                }
            } catch (e) {
                logError(e, { function: 'checkDexieEnvironment', stage: 'estimate' });
            }
        }
        issues.push({ code: error?.name || 'unknown', message: error?.message || 'Falha ao abrir IndexedDB.' });
        logError(error, { function: 'checkDexieEnvironment', stage: 'open' });
    } finally {
        // Limpa o banco de teste
        try {
            if (testDb) {
                await testDb.delete();
            }
        } catch (e) {
            logError(e, { function: 'checkDexieEnvironment', stage: 'cleanup' });
        }
    }

    return { ok: issues.length === 0, issues };
}